import React, { useMemo, useState } from 'react';
import { generateStudyPayroll } from '../../services/adminService';

const MESES = [
  { id: '01', label: 'Enero' },
  { id: '02', label: 'Febrero' },
  { id: '03', label: 'Marzo' },
  { id: '04', label: 'Abril' },
  { id: '05', label: 'Mayo' },
  { id: '06', label: 'Junio' },
  { id: '07', label: 'Julio' },
  { id: '08', label: 'Agosto' },
  { id: '09', label: 'Septiembre' },
  { id: '10', label: 'Octubre' },
  { id: '11', label: 'Noviembre' },
  { id: '12', label: 'Diciembre' },
];

const REPORTES = [
  { id: 'cobrados', label: 'Especialistas por estudios cobrados' },
  { id: 'totales', label: 'Especialistas totales' },
  { id: 'sin_reporte', label: 'Terapias sin reporte' },
];

const anios = () => {
  const actual = new Date().getFullYear();
  const lista = [];

  for (let anio = actual - 1; anio <= actual + 1; anio += 1) {
    lista.push(String(anio));
  }

  return lista;
};

const numero = (valor) => {
  const cantidad = parseFloat(String(valor || '0').replace(',', '.'));

  return Number.isFinite(cantidad) ? cantidad : 0;
};

const dinero = (valor) => numero(valor).toFixed(2);

const nombreMes = (mes) => {
  const encontrado = MESES.find((item) => item.id === mes);

  return encontrado ? encontrado.label : mes;
};

const agrupar = (filas) => {
  const grupos = [];
  const indice = {};

  filas.forEach((fila) => {
    if (!indice[fila.usuario_id]) {
      indice[fila.usuario_id] = {
        usuario_id: fila.usuario_id,
        cedula: fila.cedula,
        nombre: fila.nombre,
        filas: [],
      };
      grupos.push(indice[fila.usuario_id]);
    }

    indice[fila.usuario_id].filas.push(fila);
  });

  return grupos;
};

const NominaEstudios = ({ sessionId, onSalir }) => {
  const hoy = new Date();
  const [quincena, setQuincena] = useState(hoy.getDate() <= 15 ? '1' : '2');
  const [mes, setMes] = useState(String(hoy.getMonth() + 1).padStart(2, '0'));
  const [anio, setAnio] = useState(String(hoy.getFullYear()));
  const [reporte, setReporte] = useState('');
  const [resultado, setResultado] = useState(null);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');
  const [aviso, setAviso] = useState('');
  const [pendiente, setPendiente] = useState(false);
  const grupos = useMemo(() => agrupar(resultado ? resultado.filas : []), [resultado]);
  const titulo = quincena === '1' ? 'Primera' : 'Segunda';
  const textoFecha = titulo.toLowerCase() + ' quincena de ' + nombreMes(mes) + ' de ' + anio;

  const cambiarPeriodo = (campo) => (event) => {
    const valor = event.target.value;

    if (campo === 'quincena') {
      setQuincena(valor);
    }

    if (campo === 'mes') {
      setMes(valor);
    }

    if (campo === 'anio') {
      setAnio(valor);
    }

    setPendiente(false);
    setResultado(null);
    setReporte('');
    setAviso('');
    setError('');
  };

  const generar = (confirmar) => {
    setGuardando(true);
    setError('');
    setAviso('');
    setReporte('');

    generateStudyPayroll(sessionId, { quincena, mes, anio, confirmar: confirmar ? 1 : 0 })
      .then((datos) => {
        setResultado(datos);

        if (datos.existente) {
          setPendiente(true);
          return;
        }

        setPendiente(false);
        setAviso(datos.cerrada ? 'Esta quincena está cerrada. Se muestra lo guardado.' : 'Nómina por estudios generada.');
      })
      .catch((requestError) => {
        setResultado(null);
        setPendiente(false);
        setError(requestError.message || 'No se pudo generar la nómina por estudios.');
      })
      .finally(() => {
        setGuardando(false);
      });
  };

  return (
    <div className="admin-pre-overlay" role="presentation">
      <div className="admin-pre-panel nomina-consulta-panel" role="dialog" aria-modal="true">
        <div className="admin-pre-bar">
          <h2>Nómina por estudios</h2>
          <button type="button" className="admin-pre-close" onClick={onSalir} aria-label="Cerrar">
            ×
          </button>
        </div>
      <p className="admin-muted">
        Genera el pago por estudio de la quincena. Si está cerrada, solo se muestra lo guardado.
        También revisa la quincena anterior por estudios que no se pagaron.
      </p>
      <div className="nomina-estudios-no-print admin-form-row">
        <label className="admin-field">
          <span>Quincena</span>
          <select value={quincena} onChange={cambiarPeriodo('quincena')}>
            <option value="1">Primera quincena</option>
            <option value="2">Segunda quincena</option>
          </select>
        </label>
        <label className="admin-field">
          <span>Mes</span>
          <select value={mes} onChange={cambiarPeriodo('mes')}>
            {MESES.map((item) => (
              <option key={item.id} value={item.id}>
                {item.label}
              </option>
            ))}
          </select>
        </label>
        <label className="admin-field">
          <span>Año</span>
          <select value={anio} onChange={cambiarPeriodo('anio')}>
            {anios().map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
        </label>
      </div>
      {error ? (
        <div className="admin-alert admin-alert--error" role="alert">
          {error}
        </div>
      ) : null}
      {pendiente ? (
        <div className="admin-alert" role="status">
          <p>
            Ya existe una prenómina de la {textoFecha} y todavía no está cerrada.
            Si la generas de nuevo, se reemplaza la que está cargada.
          </p>
          <div className="admin-pre-actions">
            <button type="button" className="admin-btn admin-btn--primary" onClick={() => generar(true)} disabled={guardando}>
              {guardando ? 'Generando…' : 'Generar de nuevo'}
            </button>
            <button type="button" className="admin-btn admin-btn--secondary" onClick={() => setPendiente(false)} disabled={guardando}>
              Dejar la que está
            </button>
          </div>
        </div>
      ) : null}
      {aviso ? (
        <div className="admin-alert admin-alert--success" role="status">
          {aviso}
        </div>
      ) : null}
      {resultado ? (
        <div className="nomina-estudios-no-print admin-form-row">
          <label className="admin-field">
            <span>Seleccione un reporte</span>
            <select value={reporte} onChange={(event) => setReporte(event.target.value)}>
              <option value="">Seleccione</option>
              {REPORTES.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.label}
                </option>
              ))}
            </select>
          </label>
          <button type="button" className="admin-btn admin-btn--secondary" onClick={() => window.print()}>
            Imprimir
          </button>
        </div>
      ) : null}
      <div className="admin-pre-actions nomina-estudios-no-print">
        <button type="button" className="admin-btn admin-btn--primary" onClick={generar} disabled={guardando}>
          {guardando ? 'Generando…' : 'Generar'}
        </button>
        <button type="button" className="admin-btn admin-btn--secondary" onClick={onSalir}>
          Salir
        </button>
      </div>

      {resultado && reporte === 'cobrados' ? (
        <div className="nomina-estudios-reporte">
          <h3>
            Pre-nómina de la {titulo} quincena de {nombreMes(mes)} {anio}
          </h3>
          {grupos.length === 0 ? <p className="admin-muted">No hay estudios cobrados en esta quincena.</p> : null}
          {grupos.map((grupo) => {
            const evaluaciones = grupo.filas.reduce((suma, fila) => suma + numero(fila.monto_evaluacion), 0);
            const terapias = grupo.filas.reduce((suma, fila) => suma + numero(fila.monto_terapia), 0);

            return (
              <div key={grupo.usuario_id} className="nomina-estudios-persona">
                <div className="admin-table-wrap">
                  <table className="admin-table">
                    <thead>
                      <tr>
                        <th>Cédula</th>
                        <th>Especialista</th>
                        <th>Fecha</th>
                        <th>Cargo</th>
                        <th>T/Nómina</th>
                        <th>Documento</th>
                        <th>I.D.</th>
                        <th>Monto/Eva.</th>
                        <th>Monto/Te.</th>
                      </tr>
                    </thead>
                    <tbody>
                      {grupo.filas.map((fila) => (
                        <tr key={fila.id}>
                          <td>{fila.cedula || '—'}</td>
                          <td>{fila.nombre}</td>
                          <td>{fila.fecha}</td>
                          <td>{fila.cargo || '—'}</td>
                          <td>{fila.tipo_nomina}</td>
                          <td>{fila.documento || '—'}</td>
                          <td>{fila.cita_id}</td>
                          <td>{dinero(fila.monto_evaluacion)}</td>
                          <td>{dinero(fila.monto_terapia)}</td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan={6}>Totales</td>
                        <td>{grupo.filas.length.toFixed(2)}</td>
                        <td>{dinero(evaluaciones)}</td>
                        <td>{dinero(terapias)}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            );
          })}
        </div>
      ) : null}

      {resultado && reporte === 'totales' ? (
        <div className="nomina-estudios-reporte">
          <h3>
            Totales de la {titulo} quincena de {nombreMes(mes)} {anio}
          </h3>
          {grupos.length === 0 ? <p className="admin-muted">No hay estudios cobrados en esta quincena.</p> : null}
          {grupos.length > 0 ? (
            <div className="admin-table-wrap">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Cédula</th>
                    <th>Especialista</th>
                    <th>Estudios</th>
                    <th>Monto/Eva.</th>
                    <th>Monto/Te.</th>
                  </tr>
                </thead>
                <tbody>
                  {grupos.map((grupo) => {
                    const evaluaciones = grupo.filas.reduce((suma, fila) => suma + numero(fila.monto_evaluacion), 0);
                    const terapias = grupo.filas.reduce((suma, fila) => suma + numero(fila.monto_terapia), 0);

                    return (
                      <tr key={grupo.usuario_id}>
                        <td>{grupo.cedula || '—'}</td>
                        <td>{grupo.nombre}</td>
                        <td>{grupo.filas.length}</td>
                        <td>{dinero(evaluaciones)}</td>
                        <td>{dinero(terapias)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : null}
        </div>
      ) : null}

      {resultado && reporte === 'sin_reporte' ? (
        <div className="nomina-estudios-reporte">
          <h3>Terapias sin reporte</h3>
          {(resultado.sin_reporte || []).length === 0 ? (
            <p className="admin-muted">No hay estudios sin reporte.</p>
          ) : (
            <div className="admin-table-wrap">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Cédula</th>
                    <th>Especialista</th>
                    <th>Fecha</th>
                    <th>Cargo</th>
                    <th>Documento</th>
                    <th>I.D.</th>
                  </tr>
                </thead>
                <tbody>
                  {(resultado.sin_reporte || []).map((fila) => (
                    <tr key={fila.cita_id}>
                      <td>{fila.cedula || '—'}</td>
                      <td>{fila.nombre}</td>
                      <td>{fila.fecha}</td>
                      <td>{fila.cargo || '—'}</td>
                      <td>{fila.documento || '—'}</td>
                      <td>{fila.cita_id}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      ) : null}
      </div>
    </div>
  );
};

export default NominaEstudios;
